import { EERIE } from 'HubStyleTokens/colors';
import Small from 'UIComponents/elements/Small';
import UIIcon from 'UIComponents/icon/UIIcon';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import ApprovalStepStatusText from './ApprovalStepStatusText';
import ApprovalUserAvatar from '../user/ApprovalUserAvatar';
import ApprovalUserFormattedName from '../ApprovalUserFormattedName';
import FormattedDate from './FormattedDate';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function ApprovalStepsListItem(props) {
  const {
    approvalStep
  } = props;
  return /*#__PURE__*/_jsxs("div", {
    className: "display-flex",
    "data-test-id": "approval-steps-list-item",
    children: [/*#__PURE__*/_jsx(ApprovalUserAvatar, {
      approvalUser: approvalStep.approver
    }), /*#__PURE__*/_jsxs("div", {
      className: "display-flex flex-column m-left-5",
      "data-test-id": `product-approvals-steps-list-item-${approvalStep.approvalStepStatus}`,
      children: [/*#__PURE__*/_jsx("strong", {
        children: /*#__PURE__*/_jsx(ApprovalUserFormattedName, {
          approvalUser: approvalStep.approver
        })
      }), /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(Small, {
          use: "help",
          className: "display-inline-flex",
          children: /*#__PURE__*/_jsx(ApprovalStepStatusText, {
            approvalStepStatus: approvalStep.approvalStepStatus
          })
        }), approvalStep.approvedNote && /*#__PURE__*/_jsx(UITooltip, {
          use: "longform",
          placement: "bottom",
          title: /*#__PURE__*/_jsxs("p", {
            style: {
              fontSize: 14
            },
            children: [approvalStep.approvedNote, /*#__PURE__*/_jsx("br", {}), approvalStep.approvedNoteTimestamp && /*#__PURE__*/_jsx(FormattedDate, {
              date: approvalStep.approvedNoteTimestamp
            })]
          }),
          children: /*#__PURE__*/_jsx(UIIcon, {
            "data-test-id": "approval-steps-list-item-info",
            name: "bubble",
            color: EERIE
          })
        }), approvalStep.rejectionNote && /*#__PURE__*/_jsxs("p", {
          className: "m-bottom-0",
          children: [/*#__PURE__*/_jsx(UIIcon, {
            className: "m-right-2",
            color: EERIE,
            name: 'bubble',
            size: 12,
            "data-test-id": "approval-steps-list-item-reject-note-icon"
          }), approvalStep.rejectionNote]
        })]
      })]
    })]
  });
}
export default ApprovalStepsListItem;